import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import {Input, Button} from 'react-bootstrap'
import Icon from './Icon'
import style from './TypeaheadGridInput.less'

function escapeRegExp(value) {
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}

export function matcher({source, identify=(v) => v}) {
    return (q, cb) => {
        var matches

        if (q) {
            const regexp = new RegExp(escapeRegExp(q), 'i')
            matches = source.filter((value) => regexp.test(identify(value)))
        } else {
            matches = source
        }

        cb(matches)
    }
}

function matchesFilter(value, identify, multi) {
    return (item) => {
        if (multi) {
            return !(value && value.find((v) => identify(v) == identify(item)))
        } else {
            return (value && identify(value)) != identify(item)
        }
    }
}

class TypeaheadGridInput extends Component {
    static propTypes = {
        source: PropTypes.func.isRequired,
        display: PropTypes.func,
        identify: PropTypes.func,
        header: PropTypes.object,
        disabled: PropTypes.bool,
        multi: PropTypes.bool,
        size: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v
    }

    constructor(props) {
        super(props)

        this.state = {
            matches: []
        }
    }

    componentWillMount() {
        const {source, value, identify, multi} = this.props

        source(null, (matches) => {
            const filteredMatches = matches.filter(matchesFilter(value, identify, multi))
            this.setState({matches: filteredMatches})
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.source != this.props.source) {
            const {source, value, identify, multi} = nextProps
            const query = null
            
            source(query, (matches) => {
                const filteredMatches = matches.filter(matchesFilter(value, identify, multi))
                this.setState({query, matches: filteredMatches})
            })
        }
    }

    getQuery() {
        const {query} = this.state
        return query
    }

    _match(event) {
        const {source, value, identify, multi} = this.props
        const query = event.target.value || null

        source(query, (matches) => {
            const filteredMatches = matches.filter(matchesFilter(value, identify, multi))
            this.setState({query, matches: filteredMatches})
        })
    }

    _clear(event) {
        const {source, value, identify, multi} = this.props
        const query = null

        event.preventDefault()

        source(query, (matches) => {
            const filteredMatches = matches.filter(matchesFilter(value, identify, multi))
            this.setState({query, matches: filteredMatches})
        })
    }

    _toggle(item) {
        const {source, value, onChange, onSubmit, identify, multi} = this.props

        if (multi) {
            const arrayValue = value || []
            const itemId = identify(item)
            const index = arrayValue.findIndex((value) => identify(value) == itemId)

            if (index < 0) {
                if (onSubmit) {
                    onSubmit('Add', item)
                }

                if (onChange) {
                    var nextValue = [...arrayValue]
                    nextValue.push(item)
                    onChange(nextValue)
                }
            } else {
                if (onSubmit) {
                    onSubmit('Remove', item)
                }

                if (onChange) {
                    var nextValue = [...arrayValue]
                    nextValue.splice(index, 1)
                    onChange(nextValue)
                }
            }
        } else {
            if ((value && identify(value)) != identify(item)) {
                if (onSubmit) {
                    onSubmit('Add', item)
                }

                if (onChange) {
                    onChange(item)
                }
            } else {
                if (onSubmit) {
                    onSubmit('Remove', value)
                }

                if (onChange) {
                    onChange(null)
                }
            }
        }
    }

    _isActive(item) {
        const {identify, value, multi} = this.props

        if (multi) {
            const itemId = identify(item)
            return value && (value.find((value) => identify(value) == itemId) != null) || false
        } else {
            return (value && identify(value)) == identify(item)
        }
    }

    render() {
        const {source, display, identify, header, disabled, multi, size, labelClassName, wrapperClassName, value, onChange, onSubmit, ...other} = this.props
        const {query, matches} = this.state

        const sizeClass = size && size.toLowerCase()

        const inputButton = () => {
            if (query) {
                return (
                    <Button
                        onClick={(e) => this._clear(e)}>
                        <Icon icon='cross' size='xs' />
                    </Button>
                )
            }
        }

        const inputAddon = () => {
            if (!query) {
                return (
                    <Icon icon='search' size='xs' />
                )
            }
        }

        return (
            <div className={cx(style.default, style[sizeClass])}>
                <Input
                    type='text'
                    labelClassName={labelClassName}
                    wrapperClassName={wrapperClassName}
                    buttonAfter={inputButton()}
                    addonAfter={inputAddon()}
                    disabled={disabled}
                    value={query}
                    onChange={(e) => this._match(e)}
                    {...other} />
                <div className={style.formResult}>
                    <div className={labelClassName} />
                    <div className={wrapperClassName}>
                        {header}
                        <ul className={style.result}>
                            {matches.map((match) => (
                                <li key={identify(match)}>
                                    <Button
                                        bsStyle='link'
                                        active={this._isActive(match)}
                                        disabled={disabled}
                                        onClick={() => this._toggle(match)}>
                                        {display(match)}
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default TypeaheadGridInput


// WEBPACK FOOTER //
// ./lib/core/components/TypeaheadGridInput.js